export const SET_TASK = 'SET_TASK';
export const FETCH_TASKS = 'FETCH_TASKS';
export const CREATE_NEW_TASK = 'CREATE_NEW_TASK';
export const DELETE_TASK = 'DELETE_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const SET_ACTIVE_TASK = 'SET_ACTIVE_TASK';
export const FINISH_TASK_SESSION = 'FINISH_TASK_SESSION';
export const CREATE_TASK_SESSION = 'CREATE_TASK_SESSION';
